export enum DaznChapterEnum {
    OpenBrowse = 'openbrowse',
    LandingPage = 'landingpage',
    SignIn = 'signin',
    Auth = 'auth',
    Help = 'help',
    Error = 'error',
    account='account',
    Catalog = 'catalog',
}

export enum DaznBillingPeriod {
    Monthly = 'Month',
    Annually = 'Annual',
    Instalments = 'Instalments',
}
export enum NflBillingPeriod {
    Monthly = 'Month',
    Annually = 'Annual',
    Instalments = 'Instalments',
    Week = 'Week',
}
 export enum LpChildPages {
    nfl = 'nfl',
    recoup = 'recoup',
    nflgamepass = 'nfl-game-pass',
    'game-pass' = 'game-pass',
    nf1 = 'nf1',
 }
